/* src/components/utils/montoclpUtils.js - Modificado el 05-02-2026 */
/* -------------------- Formato pesos chilenos -------------------- */

export const formatoCLP = (valor) => {
  if (valor === null || valor === undefined) {
    return "";
  }
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(valor);
};
